import "../../sap/ui/core/date/Buddhist.js";
